import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function getPageBuilds(pageTemplateId, params = {}) {
  return axios.get(`/ajax/page_templates/${pageTemplateId}/page_builds`, { params })
}

export function getPageBuild(id) {
  return axios.get(`/ajax/page_builds/${id}`)
}

export function createPageBuild(pageTemplateId, data) {
  return axios.post(`/ajax/page_templates/${pageTemplateId}/page_builds`, data)
}

export function approvePageBuild(id, notes = null) {
  return axios.post(`/ajax/page_builds/${id}/approve`, { review_notes: notes })
}

export function rejectPageBuild(id, notes) {
  return axios.post(`/ajax/page_builds/${id}/reject`, { review_notes: notes })
}

export function publishPageBuild(id) {
  return axios.post(`/ajax/page_builds/${id}/publish`)
}

export function bulkPublishPageBuilds(buildIds) {
  return axios.post('/ajax/page_builds/bulk_publish', { build_ids: buildIds })
}

export function bulkCreatePageBuilds(pageTemplateId, data) {
  return axios.post(`/ajax/page_templates/${pageTemplateId}/page_builds/bulk_create`, data)
}
